import React from 'react'
import Detail from 'src/modules/EContent/Detail'
import { ECONTENT_TYPE } from 'src/modules/EContent/model'

const EContentFactPage = () => {
  return <Detail type={ECONTENT_TYPE.KB} />
}

export default EContentFactPage
